import { EIcons } from '@/components/atoms/at-icon/icons';
import {
  IDefaultCsProps,
  IImageGlobalCSProps,
  TSpacing,
  TSpacingProp,
} from '@/lib/contentstack-sdk/types';
import { ReactNode } from 'react';
import * as yup from 'yup';
import { formSchema } from './constants';
import { ISelectOption } from '@/components/atoms/at-dropdown-field/at-dropdown-field.types';
import { THeaderSupportedElements } from '@/components/atoms/at-header/at-header.types';
import { EAlignment } from '@/components/molecules/ml-header/ml-header.types';

export interface IOrLeadGenFormCmsProps extends IDefaultCsProps {
  title: string;
  form_id: string;
  heading: string;
  heading_element?: { select?: THeaderSupportedElements };
  heading_variant?: { select?: THeaderSupportedElements };
  description?: string;
  form_type: EFormType;
  is_in_modal?: boolean;
  top_spacing: TSpacingProp;
  bottom_spacing: TSpacingProp;
  background_image?: IImageGlobalCSProps;
  alignment?: { alignmentprop: EAlignment };
  _content_type_uid: 'lead_generation_form';
}

export enum EFormType {
  SINGLE_STEP = 'single-step',
  TWO_STEP = 'two-step',
  DOWNLOAD = 'download-gate',
  CONTACT_US = 'contact-us',
}

export interface IFormField {
  label?: string;
  id: TLeadGenFormFieldName;
  required: boolean;
  type: 'text' | 'phone' | 'email' | 'dropdown' | 'checkbox' | 'textarea';
  options?: Array<ISelectOption>;
  icon?: EIcons;
  children?: ReactNode;
  fullWidth?: boolean;
  placeholder?: string;
  rows?: number;
}

export interface IFormStep {
  key: string;
  formFields: Array<IFormField>;
  stepIndex: number;
  className?: string;
  handleNext?: () => void;
  handlePrevious?: () => void;
  handleSubmit?: () => void;
  submitToHubspot?: boolean;
  children?: ReactNode;
}

export interface IOrleadGenFormProps {
  formId: string;
  formName: string;
  heading: string;
  headingElement?: THeaderSupportedElements;
  headingVariant?: THeaderSupportedElements;
  description?: string;
  formType: EFormType;
  isInModal?: boolean;
  topSpacing?: TSpacing;
  bottomSpacing?: TSpacing;
  topDivider?: boolean;
  bottomDivider?: boolean;
  contactPageTypeUrl?: string;
  backgroundImage?: IImageGlobalCSProps;
  alignment?: 'left' | 'center' | 'right';
}

export interface IEnrichedData extends yup.InferType<typeof formSchema> {
  contactPageTypeUrl?: string;
}

export type TLeadGenFormFieldName =
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'phone'
  | 'buildLocation'
  | 'moveInDate'
  | 'isLotOwner'
  | 'marketingConsent'
  | 'topic'
  | 'comments';
